
import {
  Component,
  Prop,
  Mixins,
  Emit,
} from 'vue-property-decorator';
import {
  Dialog,
  Form,
  FormItem,
  Input,
  InputNumber,
  Select,
  Option,
  Button,
  Upload,
  Radio,
} from 'element-ui';
import { ISetting } from '@/types/set.d';
import api from '@/api/set';
import publicApi from '@/api/public';
import FormMixin from './formMixin';

@Component({
  components: {
    Dialog,
    Form,
    FormItem,
    Input,
    InputNumber,
    Select,
    Option,
    Button,
    Upload,
    Radio,
  },
})
export default class ManageBusModal extends Mixins(FormMixin) {
  @Prop({
    required: true,
    default: false,
  }) visible!: boolean;

  @Prop({
    required: false,
  }) title!: string;

  @Prop({
    required: false,
  }) oldForm!: any;

  private form: any = {
    title: '',
    sort: 0,
    description: '',
    addressList: [],
  }

  private macForm: any = {
    platform: 'mac',
    platformName: 'mac',
    downloadUrl: '',
  }

  private windows32Form: any = {
    platform: 'windows',
    platformName: 'windows32',
    downloadUrl: '',
  }

  private windows64Form: any = {
    platform: 'windows',
    platformName: 'windows64',
    downloadUrl: '',
  }


  private addressDetail: any = []

  mounted() {
    this.addressDetail = JSON.parse(this.oldForm.addressString);
  }

  addConfig() {
    this.addressDetail.push({ platform: '', platformName: '', downloadUrl: '' });
  }

  // 重置表单
  reset(close: boolean = false, refrsh: boolean = false) {
    this.form = {};
    this.macForm = {};
    this.windows32Form = {};
    this.windows64Form = {};
    if (close) this.$emit('update:visible', false);
    if (refrsh) this.$emit('refrsh');
    this.resetForm();
  }

  /**
   * @author liangyongmou
   * @desc 添加/编辑机构信息
   * @param { string } title 标题
   */
  submit(title: string) {
    this.form.addressList.push(this.windows32Form);
    this.form.addressList.push(this.macForm);
    this.form.addressList.push(this.windows64Form);
    this.loading = true;
    if (title.includes('编辑')) { // 编辑数据
      this.oldForm.addressList = this.addressDetail;
      api.editAppData(this.oldForm).then((res: any) => {
        this.reset(true, true);
        this.loading = false;
      });
    } else { // 新增数据
      api.addApp(this.form).then(() => {
        this.reset(true, true);
        this.loading = false;
        /* eslint-disable no-return-assign */
      }).catch(() => (this.loading = false));
    }
  }
}
